import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/utils/api";

export const fetchAirLoomData = createAsyncThunk(
  "cfc/fetchAirLoomData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/air-jet-looms");
      return response?.data?.data || {};
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch Air Loom form"
      );
    }
  }
);

const initialState = {
  data: {},
  current_tab: "personal",
  data_loading: false,
  user_initiated_nav: false,
  error: null,
};

const airJetLoomSlice = createSlice({
  name: "airJetLoom",
  initialState,
  reducers: {
    setData: (state, action) => {
      state.data = {
        ...(state.data || {}),
        ...(action.payload || {}),
      };
    },
    clearError: (state) => {
      state.error = null;
    },
    setCurrentTab: (state, action) => {
      state.current_tab = action.payload;
    },
    setDataLoading: (state, action) => {
      state.data_loading = action.payload;
    },
    setUserInitiatedNav: (state, action) => {
      state.user_initiated_nav = action.payload;
    },
    resetAirJetLoomSliceState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAirLoomData.pending, (state) => {
        state.data_loading = true;
        state.error = null;
      })
      .addCase(fetchAirLoomData.fulfilled, (state, action) => {
        state.data_loading = false;
        state.data = action.payload || {};
      })
      .addCase(fetchAirLoomData.rejected, (state, action) => {
        state.data_loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setData,
  setCurrentTab,
  setDataLoading,
  clearError,
  resetAirJetLoomSliceState,
  setUserInitiatedNav,
} = airJetLoomSlice.actions;
export default airJetLoomSlice.reducer;
